module.exports = __webpack_public_path__ + "img/logo-rgb-portrait-expert.3f43388e.png";